import { ISettingStore } from "@/redux/slices/settings/SettingModel";
import { ResourceInfo } from "../resource-service/entity/ResourceEntity";
import { ProcessWorkspaceRulesResult } from "./entity/ProcessWorkspaceRulesResult";
import { AttendeeInfo } from "../attendee-service/entity/AttendeeEntity";
import { IOrganizationStore } from "@/redux/slices/organizations/OrganizationModel";
import { HttpResponse } from "@/fetchInterceptor/AxiosMethod";
import { ProcessMovingOrderRequest } from "./entity/request/ProcessMovingOrderRequest";
import { MovingOrderSessionModel } from "./entity/MovingOrderSessionModel";

export const TokenIOrderService = "IOrderService";

export interface IOrderService {
  ProcessWorkspaceRules(selectedRs: Array<ResourceInfo>): Promise<ProcessWorkspaceRulesResult>;
  ShowPlaceOrderDialog(disableOrderForm: boolean, currentResource: ResourceInfo, selectedResources: ResourceInfo[], attendees: AttendeeInfo[], settings: ISettingStore, orgStore: IOrganizationStore): void;
  readonly MovingOrderSession: MovingOrderSessionModel | undefined;
  SaveMovingOrderSession(movingOrderSession: MovingOrderSessionModel): void;
  IsShownDeadlineMessage: boolean;
  IsAllowMovingOrder(request: ProcessMovingOrderRequest): Promise<boolean>;
  fetchSessionData(sessionId: string): Promise<HttpResponse<any>>;
  CheckMovingOrderCondition(request: ProcessMovingOrderRequest): Promise<MovingOrderSessionModel | undefined>;
  ShowViewOrderDialog(selectedResources: ResourceInfo[], OldResource : ResourceInfo, settings: ISettingStore, orgStore: IOrganizationStore): Promise<void>;
  ReleaseMovingOrderSession(): void;
}
